<app-default-layout [menuItems]="menuItems()"></app-default-layout>